module.exports = "/shared/fonts/helvetica-lt-black.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/helvetica-lt-black.ttf
// module id = 317
// module chunks = 13